module.exports = __webpack_public_path__ + "8ea753f29b6e27712de7ee0f6095fcf5.svg";